import { getAllowLoginSaveKey, localStorageRemoveItem } from "support/local-storage";
import { clearAppPasswordLocalStorage } from "webapp/chrome/smart/app-container/app-container-lib";
import { flagExplicitSignOut } from "./session-storage";

export function signOutAppUser(appID: string): void {
    clearAppPasswordLocalStorage(appID);
    localStorageRemoveItem(getAllowLoginSaveKey(appID));
    flagExplicitSignOut(appID);
    document.location.reload();
}
